export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-ease/src/linear.js
// module id = 497
// module chunks = 4